import { useLayout } from "context/layout/layout";
import React, { useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { PortalService } from "services/portal";
import logo from "../../../assets/white.png";
import { PasswordField } from "components/PasswordField";
import { PasswordStrengthMeter } from "components/PasswordStrengthMeter";

export function PortalResetPassword() {
  const { token } = useParams();
  const layout = useLayout();
  const navigate = useNavigate();
  const [form, setForm] = useState({ password: "", confirmPassword: "" });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = ({ target: { value, name } }) => {
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async () => {
    if (!form.password || !form.confirmPassword) {
      return layout.errorAlert({ message: "Todos los campos son obligatorios" });
    }

    if (form.password.length < 8) {
      return layout.errorAlert({ message: "La contraseña debe tener al menos 8 caracteres" });
    }

    if (form.password !== form.confirmPassword) {
      return layout.errorAlert({ message: "Las contraseñas no coinciden" });
    }

    setLoading(true);
    try {
      await PortalService.resetPassword({ token, password: form.password });
      setSuccess(true);
      layout.successAlert({ message: "Contrasena actualizada exitosamente" });
      setTimeout(() => navigate("/portal/login"), 3000);
    } catch (err) {
      const msg = err?.response?.data?.error || "Error al restablecer contrasena";
      layout.errorAlert({ message: msg });
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "0.75rem 1rem",
    fontSize: "0.95rem",
    border: "1.5px solid #e2e8f0",
    borderRadius: "0.625rem",
    outline: "none",
    transition: "border-color 0.2s, box-shadow 0.2s",
    background: "#fff",
    color: "#1e293b",
    boxSizing: "border-box",
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "#f8fafc",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          padding: "48px",
          maxWidth: "440px",
          width: "100%",
          boxShadow: "0 4px 6px rgba(0,0,0,0.07)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <img src={logo} alt="Profit" style={{ width: "120px", marginBottom: "1.5rem", filter: "invert(1)" }} />
          <h2 style={{ fontSize: "1.5rem", fontWeight: 700, color: "#0f172a", marginBottom: "0.5rem" }}>
            Nueva contrasena
          </h2>
          <p style={{ fontSize: "0.875rem", color: "#64748b" }}>
            Ingresa tu nueva contrasena
          </p>
        </div>

        {success ? (
          <div style={{ textAlign: "center" }}>
            <div
              style={{
                width: "64px",
                height: "64px",
                borderRadius: "50%",
                background: "#ecfdf5",
                color: "#059669",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 24px",
                fontSize: "28px",
              }}
            >
              &#10003;
            </div>
            <p style={{ color: "#475569", fontSize: "0.9rem", marginBottom: "24px" }}>
              Contrasena actualizada. Redirigiendo al login...
            </p>
          </div>
        ) : (
          <form autoComplete="on" onSubmit={(e) => e.preventDefault()}>
            <div style={{ marginBottom: "1.25rem" }}>
              <label style={{ display: "block", fontSize: "0.8rem", fontWeight: 600, color: "#334155", marginBottom: "0.5rem" }}>
                Nueva contraseña
              </label>
              <PasswordField
                value={form.password}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                name="password"
                placeholder="Mínimo 8 caracteres"
                autoComplete="new-password"
              />
              <PasswordStrengthMeter password={form.password} />
            </div>

            <div style={{ marginBottom: "1.75rem" }}>
              <label style={{ display: "block", fontSize: "0.8rem", fontWeight: 600, color: "#334155", marginBottom: "0.5rem" }}>
                Confirmar contraseña
              </label>
              <PasswordField
                value={form.confirmPassword}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                name="confirmPassword"
                placeholder="Repite tu contraseña"
                autoComplete="new-password"
              />
            </div>

            <button
              onClick={handleSubmit}
              disabled={loading}
              type="button"
              style={{
                width: "100%",
                padding: "0.8rem",
                fontSize: "0.95rem",
                fontWeight: 600,
                color: "#fff",
                background: loading
                  ? "#64748b"
                  : "linear-gradient(135deg, #0f172a 0%, #334155 100%)",
                border: "none",
                borderRadius: "0.625rem",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.2s",
                boxShadow: "0 2px 8px rgba(15,23,42,0.25)",
                marginBottom: "1rem",
              }}
            >
              {loading ? "Guardando..." : "Restablecer contrasena"}
            </button>

            <p style={{ textAlign: "center", fontSize: "0.85rem", color: "#64748b" }}>
              <Link
                to="/portal/login"
                style={{ color: "#0353a4", textDecoration: "none", fontWeight: 600 }}
              >
                Volver al login
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
